import SelectSingleRestaurantModal from 'components/SelectSingleRestaurantModal';
import { CompanyNode, DepartmentNode } from 'components/SelectSingleRestaurantModal/models';
import { useState } from 'react';
import { Button } from 'react-bootstrap';

function SelectSingleDepartmentDemo() {
  const [show, setShow] = useState(false);

  function handleShow() {
    setShow(true);
  }

  function handleClose() {
    setShow(false);
  }

  function handleReflect(department: CompanyNode | DepartmentNode) {
    console.log(department);
  }

  return (
    <div>
      <div className="mb-3">
        <Button onClick={handleShow}>Show tree</Button>&nbsp;
        <Button onClick={handleClose}>Close tree</Button>
      </div>

      {show && (
        <SelectSingleRestaurantModal
          isModal={false}
          defaultDataDate={new Date()}
          showDataDatePicker={false}
          allowSelectTypes={['T']}
          onClose={handleClose}
          onReflect={handleReflect}
        />
      )}
    </div>
  );
}

export default SelectSingleDepartmentDemo;
